export interface Benennbar {
  vorname: string;
  name: string;
}

export function anzeigename(p: Benennbar | null | undefined): string {
  if (!p) return "Unbekannt";
  return `${p.vorname} ${p.name}`.trim() || "Unbekannt";
}

/** Zwei Buchstaben für den Avatar ohne Foto (Vor- und Nachname). */
export function initialen(p: Benennbar | null | undefined): string {
  if (!p) return "?";
  const v = p.vorname.trim().charAt(0);
  const n = p.name.trim().charAt(0);
  const s = (v + n).toUpperCase();
  return s || "?";
}

/** Rollen als Etiketten im Personenmenü (KOPFZEILE.md, Abschnitt 3.5): Vorstand dunkel, alle weiteren hell. Admin enthält die Redaktion. */
export function rollenEtiketten(gruppen: readonly string[]): { label: string; dunkel: boolean }[] {
  const rollen = [gruppen.includes("vorstand") ? { label: "Vorstand", dunkel: true } : { label: "Mitglied", dunkel: false }];
  if (gruppen.includes("admin")) rollen.push({ label: "Admin", dunkel: false });
  else if (gruppen.includes("redaktion")) rollen.push({ label: "Redaktion", dunkel: false });
  return rollen;
}
